import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 679C0678-9688-49FD-BA71-BED740A09267
 * name arrange-bring-to-front
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrange-bring-to-front.svg
 * tags
 * - Arrange 
 * - Geographic Information System 
 */
export const ArrangeBringToFrontIcon = createSvgIcon(<><path d="M2,2H11V6H9V4H4V9H6V11H2V2M22,13V22H13V18H15V20H20V15H18V13H22M8,8H16V16H8V8Z" /></>, 'ArrangeBringToFrontIcon');
export default ArrangeBringToFrontIcon